import { render, staticRenderFns } from "./MaterialFeature.vue?vue&type=template&id=63e2cba2&scoped=true&"
import script from "./MaterialFeature.vue?vue&type=script&lang=js&"
export * from "./MaterialFeature.vue?vue&type=script&lang=js&"
import style0 from "./MaterialFeature.vue?vue&type=style&index=0&id=63e2cba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e2cba2",
  null
  
)

export default component.exports